import React from "react";
import { useTable, useRowSelect, useSortBy } from "react-table";
import { useInventoryPartTableLabels } from "../../hooks";
import { ItemsTableCheckbox } from "..";
import { Button, Spinner } from "shared";

import "./items-select-list.scss";

export const ItemsSelectList = ({
  data,
  addItem,
  removeItem,
  selectedItems,
  totalResults,
  hasMore,
  isSearching,
  onLoadMore,
}) => {
  const { columns } = useInventoryPartTableLabels("modal");
  const { getTableProps, headerGroups } = useTable({ columns, data }, useSortBy, useRowSelect);

  const handleCheckboxChecked = (ev, item) => {
    if (ev.target.checked) {
      addItem(item);
    } else {
      removeItem(item);
    }
  };

  const isChecked = (item) => {
    return !!selectedItems.find((selected) => selected.itemId === item.itemId);
  };

  return (
    <div className="table-wrap">
      <div {...getTableProps()} className="items-select-table">
        <div className="items-select-table__header items-select-table__grid">
          <div className="items-table__heading"></div>
          {headerGroups[0].headers.map((column) => (
            <div key={column.id} className="items-table__heading">
              {column.render("Header")}
            </div>
          ))}
        </div>
        <div className="items-select-table__body">
          {data.map((item) => {
            const { navigatorId } = item;
            return (
              <div key={item.itemId} className="items-select-table__row items-select-table__grid">
                <div className="items-select-table__data items-select-table__data--mobile-hide-label">
                  <ItemsTableCheckbox onChange={(e) => handleCheckboxChecked(e, item)} checked={isChecked(item)} />
                </div>
                <div
                  className="items-select-table__data items-select-table__data--ev-number"
                  data-label={columns[0].Header}
                >
                  <div>{item.itemId}</div>
                  {navigatorId && <div className="items-table__data-old-item-id">{navigatorId}</div>}
                </div>
                <div className="items-select-table__data" data-label={columns[1].Header}>
                  {item.name}
                </div>
                {item.serialNumber && (
                  <div className="items-select-table__data" data-label={columns[2].Header}>
                    {item.serialNumber}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="items-select-list__footer">
        <div className="items-select-list__status-text">
          {!isSearching && totalResults > 0 && (
            <span>
              Prikazano {data.length} od {totalResults}
            </span>
          )}
        </div>

        {!isSearching && hasMore && (
          <Button buttonText="Učitaj još" className="items-select-list__button" buttonColor="link" event={onLoadMore} />
        )}
        {isSearching ? (
          <div className="items-select-list__loader">
            <Spinner />
          </div>
        ) : null}
      </div>
    </div>
  );
};
